export default __webpack_public_path__ + "0919c8b1cce595d295422246fbc443af.png";